import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Collapse,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { useGetFolderByName } from '../../Document.hook';
import { DocumentFolderUploadComponentProps } from './DocumentFolderUpload';

export const DocumentFolderUploadExists: React.FC<DocumentFolderUploadComponentProps> = (
  props: DocumentFolderUploadComponentProps
) => {
  const {
    content,
    actions,
    folderName,
    parentFolder,
    onLoad,
    onError,
    onSelect
  } = props;
  const [{ data, isLoading, error }, getFolder] = useGetFolderByName();
  const parentPath: string | undefined = parentFolder?.path;

  useEffect(() => {
    onLoad?.(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    if (folderName) {
      getFolder(folderName, parentPath);
    } else {
      onSelect?.(undefined, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentPath, folderName, getFolder]);

  useEffect(() => {
    if (!error) {
      return;
    }
    // if no folder found, handle select
    if (error.statusCode === 404) {
      onSelect?.(undefined, false);
    } else {
      onError?.(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <>
      <Collapse in={isLoading} style={{ minHeight: 'unset' }}>
        <DialogContent>
          <DialogContentText>Checking for existing folder...</DialogContentText>
        </DialogContent>
      </Collapse>
      <Collapse in={!!data} style={{ minHeight: 'unset' }}>
        <Box mx={3} mt={1}>
          <Alert severity='warning'>
            Folder <strong>{data?.name || '?'}</strong> already exists. Upload
            to existing folder or create a new folder.
          </Alert>
        </Box>
      </Collapse>
      {content}
      <DialogActions>
        {actions}
        <Button
          color='primary'
          variant='outlined'
          disabled={isLoading}
          onClick={() => onSelect?.(undefined, !!data)}
        >
          Create New Folder
        </Button>
        <Button
          color='primary'
          variant='contained'
          disabled={isLoading || !data}
          onClick={() => onSelect?.(data, true)}
        >
          Upload to Existing
        </Button>
      </DialogActions>
    </>
  );
};

export default DocumentFolderUploadExists;
